const vertexShader = `
  varying vec2 vUv;
  void main(){
    vUv = uv;
    gl_Position = projectionMatrix*viewMatrix*modelMatrix*vec4( position, 1.0 );
  }
`;

// fragmentShdaer字符串
const fragmentShader = `
  uniform sampler2D texture1;
  uniform sampler2D texture2;
	uniform float flowRate;
	uniform float flowConstant;
	uniform float width;
	uniform vec3 centerColor;
	uniform vec3 edgeColor;
  varying vec2 vUv;

  vec3 rgb2hsv(vec3 c) {
    vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));

    float d = q.x - min(q.w, q.y);
    float e = 1.0e-10;
    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
  }

  vec3 hsv2rgb(vec3 c) {
    vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
  }

  vec3 mixHsv(vec3 hsv1, vec3 hsv2, float t) {
    float h = mix(hsv1.x, hsv2.x, t);
    float s = mix(hsv1.y, hsv2.y, t);
    float v = mix(hsv1.z, hsv2.z, t);
    return vec3(h, s, v);
  }

  void main() {
    vec4 color1 = texture2D( texture1, vUv);
    vec4 color2 = texture2D( texture2, vUv);
      
		if (color2.a < 0.5) {
			gl_FragColor = color1;
		} else {
      float distance = abs(flowRate * vUv.x - vUv.y + flowConstant) / sqrt(flowRate * flowRate + 1.0);
      if (distance < width) {
        float colorOpacity = 1.0 - distance / width;
        vec3 hsvCenterColor = rgb2hsv(centerColor);
        vec3 hsvEdgeColor = rgb2hsv(edgeColor);
        vec3 mixedHsv = mixHsv(hsvCenterColor, hsvEdgeColor, colorOpacity);
        vec3 mixColor = hsv2rgb(mixedHsv);
        gl_FragColor = vec4(mixColor, 1.0) * colorOpacity + color1 * (1.0 - colorOpacity);
        
			} else {
				gl_FragColor = color1;
			}
    }
  }
`;

export { vertexShader, fragmentShader };
